import React, { useState } from "react";
import PropTypes from "prop-types";

import InspirationExplorerConfig from "./InspirationExplorer.config";
import InspirationExplorerSchema from "./InspirationExplorer.schema";

import "../../../assets/stylesheets/toolBase.css";

/**
 * InspirationExplorerTool
 *
 * Visual exploration tool that helps users browse styles,
 * budgets, and project inspiration before committing.
 */
const InspirationExplorerTool = ({ category }) => {
  const {
    title,
    description,
    styleGroups,
    budgetRanges,
    defaults,
    ctaLabel,
    result,
  } = InspirationExplorerConfig;

  const [selections, setSelections] = useState({ ...defaults });
  const [hasSubmitted, setHasSubmitted] = useState(false);

  const handleSelect = (field, value) => {
    setSelections((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Placeholder: recommendation / filtering logic goes here
    setHasSubmitted(true);
  };

  return (
    <div className="tool inspiration-explorer-tool">
      {/* =====================================================
          Header
         ===================================================== */}
      <header className="tool-header">
        <h1 className="tool-title">{title}</h1>
        <p className="tool-description">{description}</p>
      </header>

      {/* =====================================================
          Style Selection
         ===================================================== */}
      <form style={{marginTop: -42 }} onSubmit={handleSubmit}>
        <div className="tool-section">
          <strong>Select a Style</strong>

          <div className="tool-form">
            {styleGroups.map((style) => (
              <label key={style.value}>
                <input
                  type="radio"
                  name="style"
                  value={style.value}
                  checked={selections.style === style.value}
                  onChange={() =>
                    handleSelect("style", style.value)
                  }
                />{" "}
                {style.label}
              </label>
            ))}
          </div>
        </div>

        {/* =====================================================
            Budget Selection
           ===================================================== */}
        <div className="tool-section">
          <strong>Budget Range</strong>

          <div className="tool-form">
            {budgetRanges.map((budget) => (
              <label key={budget.value}>
                <input
                  type="radio"
                  name="budget"
                  value={budget.value}
                  checked={selections.budget === budget.value}
                  onChange={() =>
                    handleSelect("budget", budget.value)
                  }
                />{" "}
                {budget.label}
              </label>
            ))}
          </div>
        </div>

        {/* Actions */}
        <div className="tool-actions">
          <button type="submit" className="tool-button-primary">
            {ctaLabel}
          </button>
        </div>
      </form>

      {/* =====================================================
          Results (Placeholder)
         ===================================================== */}
      {hasSubmitted && (
        <section className="tool-results">
          <div className="tool-result-card">
            <strong>{result.title}</strong>
            <p className="tool-muted">{result.disclaimer}</p>
          </div>

          <div className="tool-result-card">
            <strong>What to Expect</strong>
            <p className="tool-muted">
              Visual inspiration and realistic expectations will appear here
              once recommendation logic is implemented.
            </p>
          </div>
        </section>
      )}
    </div>
  );
};

InspirationExplorerTool.propTypes = {
  category: PropTypes.string,
};

export default InspirationExplorerTool;
